import React from 'react';
import { convertToRaw, EditorState, Modifier, SelectionState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import _ from 'lodash';
import { Box, Typography } from '@material-ui/core';
import { NEW_BED_STATUS_LENGTH } from '../comm/constant';
import bsApp, { bedP, bsStatusP, missingStatus, statusP, remarkP } from '../page/BedStatus/bsApp';
import Occupieddischarge from '../page/BedStatus/components/PopWindows/Occupieddischarge';
import Available from '../page/BedStatus/components/PopWindows/Available';
import AvaliableUnavaliableTbc from '../page/BedStatus/components/PopWindows/AvaliableUnavaliableTbc';
import TbcAvailable from '../page/BedStatus/components/PopWindows/TbcAvailable';
import Canceldischarge from '../page/BedStatus/components/PopWindows/Canceldischarge';
import { i18n } from '../language';
import RemaksIcon from '../page/BedStatus/components/BedStatusIcon/RemaksIcon';
import { eadmissionAPI } from '../apis';
import { bsMlookupListFunc } from '../page/BedStatus/bsEnumeration';
import aesGcmUtil from './aesGcmUtil';
import { getArrayRandomKey, initValue } from '.';

// 判断拖拽时会不会跟其他cubicle重叠
export function isOverlapping(rectA, rectB) {
  // 最小边距
  const margin = 10;
  // 计算矩形A的边界
  const leftA = rectA.x - margin;
  const rightA = rectA.x + rectA.width + margin;
  const topA = rectA.y - margin;
  const bottomA = rectA.y + rectA.height + margin;

  // 计算矩形B的边界
  const leftB = rectB.x;
  const rightB = rectB.x + rectB.width;
  const topB = rectB.y;
  const bottomB = rectB.y + rectB.height;

  if (rectA.id === rectB.id) {
    return false;
  }

  // 如果 rectA 的右侧小于等于 rectB 的左侧，或者 rectA 的左侧大于等于 rectB 的右侧，
  // 并且 rectA 的底部小于等于 rectB 的顶部，或者 rectA 的顶部大于等于 rectB 的底部，
  // 则两个矩形没有重叠
  return !(leftA > rightB || rightA < leftB || topA > bottomB || bottomA < topB);
}

// 添加cubicle，往下叠加
export function addNonOverlappingElement(elements, newElement) {
  const result = [...elements];
  let i = 0;

  while (i < result.length) {
    const currentElement = result[i];

    if (
      newElement.x < currentElement.x + currentElement.width &&
      newElement.x + newElement.width > currentElement.x &&
      newElement.y < currentElement.y + currentElement.height &&
      newElement.y + newElement.height > currentElement.y
    ) {
      // 与当前元素重叠，下移 newElement 的位置
      newElement.y = Math.max(newElement.y, currentElement.y + currentElement.height + 10);
      i = 0; // 从头开始重新检查新的位置是否重叠
    } else {
      i++;
    }
  }

  return newElement;
}

// 生成新的栅格床位
export function generateGrid(row, column) {
  const grid = [];

  for (let r = 0; r < row; r++) {
    for (let c = 0; c < column; c++) {
      const cell = {
        row: r + 1,
        column: c + 1,
        key: `(${r + 1},${c + 1})`,
      };
      grid.push(cell);
    }
  }

  return grid;
}

export function initColor(gender) {
  switch (gender) {
    case 'M':
      return 'Blue';
    case 'F':
      return 'Pink';
    case 'X':
      return 'Purple';
    default:
      return '';
  }
}

let wakeLock = null;
// 开启不锁屏模式
export const requestWakeLock = async () => {
  try {
    wakeLock = await navigator.wakeLock.request('screen');
    wakeLock.addEventListener('release', () => {
      console.log('Screen Wake Lock was released');
    });
    console.log('Screen Wake Lock is active');
  } catch (err) {
    console.error(`${err.name}, ${err.message}`);
  }
};

export const closeWakeLock = () => {
  if (wakeLock !== null) {
    wakeLock.release().then(() => {
      wakeLock = null;
      console.log('Screen Wake Lock was released');
    });
  }
};

// 进入全屏
export const enterFullscreen = () => {
  const element = document.documentElement;

  if (element.requestFullscreen) {
    element.requestFullscreen();
  } else if (element.mozRequestFullScreen) {
    // Firefox
    element.mozRequestFullScreen();
  } else if (element.webkitRequestFullscreen) {
    // Chrome, Safari and Opera
    element.webkitRequestFullscreen();
  } else if (element.msRequestFullscreen) {
    // IE/Edge
    element.msRequestFullscreen();
  }
  requestWakeLock();
};

// 退出全屏
export const exitFullscreen = () => {
  if (
    document.fullscreenElement ||
    document.mozFullScreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement
  ) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
    closeWakeLock();
  }
};

// 从 waiting list 拖到cubicle的空位置上
export const handleDragFromWaitToEmpty = (setCubicleList, destination, sourceBed, setDragedBedList) => {
  setCubicleList((o) => {
    return _.map(o, (item) => {
      if (item.id === destination.cubicleId) {
        return {
          ...item,
          data: {
            ...item.data,
            beds: _.map(item.data.beds, (bedItem) => {
              if (
                Number(destination.row) === Number(bedItem.row) &&
                Number(destination.column) === Number(bedItem.column)
              ) {
                return {
                  ...bedItem,
                  data: {
                    ...sourceBed,
                    linkeds: [
                      {
                        bedNo: sourceBed.bedNo,
                        ccWardCd: sourceBed.ccWardCd,
                        bedStatusId: sourceBed.bedStatusId,
                        status: sourceBed.status,
                      },
                    ],
                  },
                };
              } else {
                return bedItem;
              }
            }),
          },
        };
      } else {
        return item;
      }
    });
  });
  setDragedBedList((o) => {
    return [...o, sourceBed];
  });
};

// 从 cubicle 上拖到其他cubicle的空位置上
export const handleDragFromCubicleToEmpty = (setCubicleList, source, destination) => {
  const hanldeItemIsdestinationResult = ({ item, sourceBed }) => ({
    ...item,
    data: {
      ...item.data,
      beds: _.map(item.data.beds, (bedItem) => {
        if (
          destination.cubicleId === source.cubicleId &&
          Number(source.row) === Number(bedItem.row) &&
          Number(source.column) === Number(bedItem.column)
        ) {
          return {
            ...bedItem,
            data: null,
          };
        } else if (
          Number(destination.row) === Number(bedItem.row) &&
          Number(destination.column) === Number(bedItem.column)
        ) {
          return {
            ...bedItem,
            data: sourceBed,
          };
        } else {
          return bedItem;
        }
      }),
    },
  });

  setCubicleList((o) => {
    const sourceCubicle = _.find(o, (item) => item.id === source.cubicleId);
    const sourceBed = _.find(
      sourceCubicle.data.beds,
      (item) => Number(source.row) === Number(item.row) && Number(source.column) === Number(item.column)
    ).data;

    return _.map(o, (item) => {
      if (item.id === destination.cubicleId) {
        return hanldeItemIsdestinationResult({ item, sourceBed });
      } else if (item.id === source.cubicleId) {
        return {
          ...item,
          data: {
            ...item.data,
            beds: _.map(item.data.beds, (bedItem) => {
              if (Number(source.row) === Number(bedItem.row) && Number(source.column) === Number(bedItem.column)) {
                return {
                  ...bedItem,
                  data: null,
                };
              } else {
                return bedItem;
              }
            }),
          },
        };
      } else {
        return item;
      }
    });
  });
};

// 通过 cubicle id 和 row 以及 column 获取到对应的 bed
export const getBedByCubicleIdAndPosition = (cubicleList, cubicleId, row, column) => {
  let bed;

  _.forEach(cubicleList, (item) => {
    if (item.id === cubicleId) {
      bed = _.find(
        item.data.beds,
        (bedItem) => Number(bedItem.row) === Number(row) && Number(bedItem.column) === Number(column)
      )?.data;
    }
  });

  return bed;
};

// 通过 cubicle id 和 row 以及 column 获取相应位置的 bed 并更新它
export const updateBedByCubicleIdAndPosition = ({ setCubicleList, cubicleId, row, column, data }) => {
  setCubicleList((o) =>
    _.map(o, (item) => {
      if (item.id === cubicleId) {
        return {
          ...item,
          data: {
            ...item.data,
            beds: _.map(item.data.beds, (bedItem) => {
              if (Number(bedItem.column) === Number(column) && Number(bedItem.row) === Number(row)) {
                return {
                  ...bedItem,
                  data,
                };
              } else {
                return bedItem;
              }
            }),
          },
        };
      } else {
        return item;
      }
    })
  );
};

// 拖拽创建 link bed
export const createLinkBed = (sourceBed, destinationBed, linkedBedNo) => {
  const mainBed = getMainLinkedBed([sourceBed, destinationBed]);

  return {
    ...mainBed,
    linkedBedNo,
    linkeds: [sourceBed, destinationBed],
  };
};

// 拖拽添加到 linked bed
export const updateLinkedBed = (sourceBed, destinationBed) => {
  const mainBed = getMainLinkedBed([sourceBed, destinationBed]);

  return {
    ...mainBed,
    linkedBedNo: destinationBed.linkedBedNo,
    linkeds: [
      ...destinationBed.linkeds,
      {
        bedNo: sourceBed.bedNo,
        ccWardCd: sourceBed.ccWardCd,
        bedStatusId: sourceBed.bedStatusId,
      },
    ],
  };
};

// 获取linked bed的主床位
export const getMainLinkedBed = (linkeds) => {
  const rank = {
    O: 5,
    OD: 4,
    TBC: 3,
    U: 2,
    A: 1,
  };
  let mainBed;

  const sortedData = linkeds.sort((a, b) => {
    const priorityA = rank[a.status];
    const priorityB = rank[b.status];

    if (priorityA === priorityB) {
      return b.bedStatusId - a.bedStatusId; // 如果status等级相同，则id越大越高级
    } else {
      return priorityB - priorityA; // 按status等级排序
    }
  });

  mainBed = sortedData[0];

  return mainBed;
};

// 判断床是否出N(NEATS)的icon
export const showNeatsIcon = (allData) => {
  // 下面两种情况会show N 图标
  // 1、当床位的dischgDest字段是下面几个值的时候展示
  // 2、当床位的ntssCreateDtm字段有值，并且status是OD的时候展示
  const showIconVal = ['HN', 'CRN', 'OAN', 'OHN'];
  const dischargeDestination = allData?.[bedP.dischargeDestination];
  const status = allData?.[bedP.status];
  const ntssCreateDtm = allData?.[bedP.ntssCreateDtm];

  return _.includes(showIconVal, dischargeDestination) || (ntssCreateDtm && status === 'OD');
};

// 处理 landing page 里面的 filter 过滤床位
export const handleBedsFilter = (filterData, bed) => {
  if (!filterData) {
    return true;
  }
  let statusFlag = false;
  let ramarkFlag = false;
  const filter = Object.entries(filterData)
    .filter(([_key, value]) => value === true)
    .map(([key, _value]) => key);

  const statusFilter = _.filter(filter, (item) => _.some(bsStatusP, (statusItem) => statusItem === item));

  const remarksFilter = _.filter(filter, (item) => !_.some(statusFilter, (statusItem) => statusItem === item));

  if (statusFilter.length === 0 || (statusFilter.length > 0 && _.some(statusFilter, (item) => item === bed.status))) {
    statusFlag = true;
  }

  if (
    remarksFilter.length === 0 ||
    (remarksFilter.length > 0 &&
      _.some(remarksFilter, (item) => {
        switch (item) {
          case bsApp.NEATS:
            return showNeatsIcon(bed);
          case bsApp.BASIC_CLEANSING:
            return bed[bedP.bedCleaning] === 'B';
          case bsApp.TERMINAL_DISINFECTION:
            return bed[bedP.bedCleaning] === 'TD';
          case bsApp.RETURN_DAY_CASE:
            return bed[bedP.returnDayCase] === 'Y';
          case bsApp.PENDING_ADMISSION:
            return bed[bedP.forClinicalAdmission] || bed[bedP.transferInRequestInfo];
          case bsApp.RESUSITATION:
            return bed[bedP.resuscitation];
          case bsApp.MAINTANIENCE:
            return bed[bedP.maintenance];
          case bsApp.LIFE_SAVING_EQUIPMENT:
            return bed[bedP.lifeSavingEquipment];
          case bsApp.AIRBORNE_PRECAUTION:
            return bed[bedP.airbornePrecaution];
          case bsApp.DROPLET_PRECAUTION:
            return bed[bedP.dropletPrecaution];
          case bsApp.CONTACT_PRECAUTION:
            return bed[bedP.contactPrecaution];
          case bsApp.ATTENTION:
            return bed[bedP.attention];
          case bsApp.ADDED_BED:
            return bed[bedP.bedType] === 'E';
          case bsApp.DAY_BED:
            return bed[bedP.bedType] === 'D';
          case bsApp.REVERSE_LSOLATION:
            return bed[bedP.reverseLsolation];
          case bsApp.COVID_19:
            return bed[bedP.covidPositivePat];
          case bsApp.HOME_LEAVE:
            return bed[bedP.homeLeaveType] === 1;
          case bsApp.HOME_LEAVE_OVERTIME:
            return bed[bedP.homeLeaveType] === 2;
          case bsApp.TO:
            return bed[bedP.transferOutRequestInfo];
          case bsApp.FROZEN:
            return bed[bedP.frozenYn] === 1;
          case bsApp.MISSING:
            return bed[bedP.missingStatus] === missingStatus.missing;
          case bsApp.MISSING_CLOSED:
            return bed[bedP.missingStatus] === missingStatus.missingClose;
          case bsApp.MDRO_CONTACT:
            return bed[bedP.mdroInfo]?.length > 0;
          case bsApp.CMS_ALERT:
            return Array.isArray(bed[bedP.cmsAlertInfos]) && bed[bedP.cmsAlertInfos].length > 0;
          case bsApp.ELDERLY_HOME:
            return Boolean(bed[bedP.elderlyHome]);
          default:
            return false;
        }
      }))
  ) {
    ramarkFlag = true;
  }

  return statusFlag && ramarkFlag;
};

// 初始化edit floor plan 里面cubicle上的bed的数据
export const initBedData = (cubRows, cubColums, bedNos) => {
  return _.map(generateGrid(cubRows, cubColums), (gridItem) => {
    const bed = _.find(
      bedNos,
      (bedItem) =>
        Number(bedItem.bedRow) === Number(gridItem.row) && Number(bedItem.bedColumn) === Number(gridItem.column)
    );
    if (bed) {
      return {
        ...gridItem,
        data: {
          ...bed,
          linkedId: null,
          linkeds: bed.linkeds
            ? [
                ...bed.linkeds,
                {
                  bedNo: bed.bedNo,
                  ccWardCd: bed.ccWardCd,
                  bedStatusId: bed.bedStatusId,
                  status: bed.status,
                },
              ]
            : [
                {
                  bedNo: bed.bedNo,
                  ccWardCd: bed.ccWardCd,
                  bedStatusId: bed.bedStatusId,
                  status: bed.status,
                },
              ],
        },
      };
    } else {
      return gridItem;
    }
  });
};

// 处理把床位从waiting拖到cubicle上
export const handleDragFromWaitingList = ({
  waitBeds,
  e,
  destinationBed,
  setCubicleList,
  destination,
  setDragedBedList,
  setFirstLinkPopup,
  setFirstLinkObj,
}) => {
  const sourceBed = _.find(waitBeds, (item) => Number(item.bedStatusId) === Number(e.draggableId));
  // 来自右边 waiting list 的床位
  if (destinationBed) {
    // 放到有床位的地方
    if (destinationBed.linkeds?.length > 1) {
      // 放到已创建link的床位上
      const newLinkedBed = updateLinkedBed(sourceBed, destinationBed);
      updateBedByCubicleIdAndPosition({
        setCubicleList,
        cubicleId: destination.cubicleId,
        row: destination.row,
        column: destination.column,
        data: newLinkedBed,
      });
      setDragedBedList((o) => {
        return [...o, sourceBed];
      });
    } else {
      // 放到没创建link的床位上
      setFirstLinkPopup(true);
      setFirstLinkObj({
        from: {
          bed: sourceBed,
        },
        to: {
          cubicleId: destination.cubicleId,
          row: destination.row,
          column: destination.column,
        },
        type: 'Wait',
      });
    }
  } else {
    // 放到空床位上
    handleDragFromWaitToEmpty(setCubicleList, destination, sourceBed, setDragedBedList);
  }
};

// 处理把床位从cubicle拖到cubicle上
export const handleDragFromCubicle = ({
  destinationBed,
  cubicleList,
  source,
  setCubicleList,
  destination,
  setFirstLinkPopup,
  setFirstLinkObj,
}) => {
  if (destinationBed) {
    // 放到有床位的地方
    const sourceBed = getBedByCubicleIdAndPosition(cubicleList, source.cubicleId, source.row, source.column);
    if (sourceBed?.linkeds?.length > 1) {
      // 已经linked的床位无法放到其他床位上
      return;
    }
    if (destinationBed.linkeds?.length > 1) {
      // 放到已创建link的床位上
      const newLinkedBed = updateLinkedBed(sourceBed, destinationBed);
      updateBedByCubicleIdAndPosition({
        setCubicleList,
        cubicleId: destination.cubicleId,
        row: destination.row,
        column: destination.column,
        data: newLinkedBed,
      });
      updateBedByCubicleIdAndPosition({
        setCubicleList,
        cubicleId: source.cubicleId,
        row: source.row,
        column: source.column,
        data: null,
      });
    } else {
      // 放到没创建link的床位上
      setFirstLinkPopup(true);
      setFirstLinkObj({
        from: {
          cubicleId: source.cubicleId,
          row: source.row,
          column: source.column,
        },
        to: {
          cubicleId: destination.cubicleId,
          row: destination.row,
          column: destination.column,
        },
        type: 'Cubicle',
      });
    }
  } else {
    // 放到空床位上
    handleDragFromCubicleToEmpty(setCubicleList, source, destination);
  }
};

// draft 保持原有文本的情况下插入新的文本
export const editorStateInsertText = (existingEditorState, text) => {
  // 要添加的新文字和换行符
  const newText = `\n${text}`;

  // 获取当前的 ContentState
  const contentState = existingEditorState.getCurrentContent();

  // 获取最后一个块的 key
  const lastBlock = contentState.getLastBlock();
  const lastBlockKey = lastBlock.getKey();

  // 获取最后一个块的文本长度
  const lastBlockTextLength = lastBlock.getLength();

  // 创建一个新的 SelectionState，选择最后一个块的文本末尾
  const selectionState = SelectionState.createEmpty(lastBlockKey).merge({
    anchorOffset: lastBlockTextLength,
    focusOffset: lastBlockTextLength,
  });

  // 使用 Modifier.insertText 插入新文字
  const contentStateWithNewText = Modifier.insertText(contentState, selectionState, newText);

  // 创建一个新的块来包含新的文字
  const newBlock = contentStateWithNewText.getLastBlock();

  // 将新的块合并到 ContentState 中
  const updatedContentState = contentStateWithNewText.merge({
    blockMap: contentStateWithNewText.getBlockMap().set(newBlock.getKey(), newBlock),
    selectionAfter: selectionState,
  });

  // 更新 editorState
  const newEditorState = EditorState.push(existingEditorState, updatedContentState, 'insert-characters');

  const newContentState = newEditorState.getCurrentContent();
  const newTextLength = newContentState.getPlainText().length;

  // 检查字数是否超过上限
  if (newTextLength <= NEW_BED_STATUS_LENGTH.MEMO_REMARKS) {
    return newEditorState;
  } else {
    return existingEditorState;
  }
};

// 处理删除embed的bug
export const handleDeleteEmbedBug = (editorState) => {
  const data = convertToRaw(editorState.getCurrentContent());

  // 找出 embed 的 key
  const embedKeys = _.filter(
    _.map(data.entityMap, (item, index) => (item.type === 'EMBEDDED_LINK' ? index : null)),
    (item) => item
  );

  let embedBlockIndexs = [];
  let errorBlockIndexs = [];

  // 找出 iframe 的索引
  _.forEach(data.blocks, (item, index) => {
    if (
      _.some(item.entityRanges, (entityItem) => _.some(embedKeys, (embedItem) => entityItem.key === Number(embedItem)))
    ) {
      embedBlockIndexs.push(index);
    }
  });

  // 检查 embed 正不正常
  _.forEach(embedBlockIndexs, (item) => {
    const block = data.blocks[item - 1];
    if (
      block &&
      block.depth === 0 &&
      block.entityRanges.length === 0 &&
      block.inlineStyleRanges.length === 0 &&
      block.text === '' &&
      block.type === 'unstyled'
    ) {
      return;
    } else {
      errorBlockIndexs.push(item);
    }
  });

  _.forEach(errorBlockIndexs, (item) => {
    delete data.blocks[item];
  });

  data.blocks = _.filter(data.blocks, (item) => item);

  return draftToHtml(data);
};

// 判断bed status床位状态显示哪些icon的方法 -------- start -------

// 控制status icon的显示位置, 左/右/上
export const positionRemaks = (allData, editFloorPlan, RemaksIcon) => {
  const filter = (filterRemaks, position) => {
    // filterRemaks stand for which icon you wanna show
    const result = [];
    _.forEach(remarks, (item, id) => {
      // 如果api返回的字段跟top里面的icon对的上，就返回对应的icon
      if (filterRemaks.hasOwnProperty(item)) {
        // if top icon container have a key that remarks(array) have too, then show icon correspondingly(by push it into a new array)
        const iconProps = {
          key: `${position}-${item}-${id}`,
          typeName: item,
          position,
        };
        const Icon = React.createElement(RemaksIcon, iconProps);
        result.push(Icon);
      }
    });
    return result;
  };
  const remarks = getBedOtherStatus(allData, editFloorPlan);

  return {
    top: () => {
      // top 可能展示的所有标签
      const topRemaks = {
        [bsApp.AIRBORNE_PRECAUTION]: 1, // if the items of this object include the bed status item, then push the icon to array to show on page
        [bsApp.DROPLET_PRECAUTION]: 1,
        [bsApp.CONTACT_PRECAUTION]: 1,
        [bsApp.REVERSE_LSOLATION]: 1,
      };
      return filter(topRemaks, 'top');
    },
    left: () => {
      const leftRemaks = {
        [bsApp.ATTENTION]: 1,
        [bsApp.DISCHARGING]: 1,
        [bsApp.DAY_BED]: 1,
        [bsApp.ADDED_BED]: 1,
        [bsApp.FROZEN]: 1,
        [bsApp.HOME_LEAVE]: 1,
        [bsApp.HOME_LEAVE_OVERTIME]: 1,
        [bsApp.NEATS]: 1,
        [bsApp.RETURN_DAY_CASE]: 1,
        [bsApp.TO]: 1,
        [bsApp.ELDERLY_HOME]: 1,
      };
      return filter(leftRemaks, 'left');
    },
    right: () => {
      const rightRemaks = {
        [bsApp.BASIC_CLEANSING]: 1,
        [bsApp.BASIC_CLEANSING_ONGOING]: 1,
        [bsApp.TERMINAL_DISINFECTION]: 1,
        [bsApp.TERMINAL_DISINFECTION_ONGOING]: 1,
        [bsApp.PENDING_ADMISSION]: 1,
        [bsApp.RESUSITATION]: 1,
        [bsApp.MAINTANIENCE]: 1,
        [bsApp.LIFE_SAVING_EQUIPMENT]: 1,
        [bsApp.COVID_19]: 1,
      };
      return filter(rightRemaks, 'right');
    },
  };
};

// 把api返回字段和本地字段进行对应
export const getBedStatus = (allData, editFloorPlan) => {
  if (editFloorPlan) {
    return allData?.[bedP.status] === bsApp.UNAVAILABLE ? bsApp.UNAVAILABLE : bsApp.TBC;
  }

  // 病床基本状态 -> 对应api的status字段
  const missing = allData?.[bedP.missingStatus];
  if (missing === missingStatus.missing) {
    return statusP.MISSING;
  } else if (missing === missingStatus.missingClose) {
    return statusP.MISSING_CLOSED;
  } else {
    return allData?.[bedP.status];
  }
};

export const handleNewRemarks = (allData, newRarks) => {
  if (allData?.[bedP.bedType] === 'E') {
    newRarks.push(remarkP.ADDED_BED);
  }
  if (allData?.[bedP.bedType] === 'D') {
    newRarks.push(remarkP.DAY_BED);
  }
  // if (allData?.[bedP.ntssCreateDtm] && allData?.[bedP.status] === 'OD') {
  //   newRarks.push(remarkP.NEATS);
  // }
  if (allData?.[bedP.reverseLsolation]) {
    newRarks.push(remarkP.REVERSE_LSOLATION);
  }
  if (allData?.[bedP.covidPositivePat]) {
    newRarks.push(remarkP.COVID_19);
  }
  if (allData?.[bedP.homeLeaveType] === 1) {
    newRarks.push(remarkP.HOME_LEAVE);
  }
  if (allData?.[bedP.homeLeaveType] === 2) {
    newRarks.push(remarkP.HOME_LEAVE_OVERTIME);
  }
  if (allData?.[bedP.transferOutRequestInfo]) {
    newRarks.push(remarkP.TO);
  }
  if (allData?.[bedP.frozenYn] === 1) {
    newRarks.push(remarkP.FROZEN);
  }
};

const handleUnavailableRemark = (allData, status, newRarks) => {
  if (status !== bsApp.UNAVAILABLE) {
    if (allData?.[bedP.airbornePrecaution]) {
      newRarks.push(remarkP.AIRBORNE_PRECAUTION);
    }
    if (allData?.[bedP.dropletPrecaution]) {
      newRarks.push(remarkP.DROPLET_PRECAUTION);
    }
    if (allData?.[bedP.contactPrecaution]) {
      newRarks.push(remarkP.CONTACT_PRECAUTION);
    }
  }
};

const handleEditModeReturnRemarks = (status, newRarks) =>
  _.filter(newRarks, (item) => {
    if (status === bsApp.TBC) {
      return item === remarkP.DAY_BED || item === remarkP.ADDED_BED;
    } else {
      return (
        item === remarkP.MAINTANIENCE ||
        item === remarkP.RESUSITATION ||
        item === remarkP.LIFE_SAVING_EQUIPMENT ||
        item === remarkP.DAY_BED ||
        item === remarkP.ADDED_BED ||
        item === remarkP.FROZEN
      );
    }
  });

// 病床的其他状态 -> api的剩余字段
export const getBedOtherStatus = (allData, editFloorPlan) => {
  const status = getBedStatus(allData, editFloorPlan);

  const newRarks = [];
  if (showNeatsIcon(allData)) {
    newRarks.push(remarkP.NEATS);
  }
  if (allData?.[bedP.bedCleaning] === 'B') {
    newRarks.push(allData?.[bedP.proceedCleansing] === 1 ? remarkP.BASIC_CLEANSING_ONGOING : remarkP.BASIC_CLEANSING);
  }
  if (allData?.[bedP.bedCleaning] === 'TD') {
    newRarks.push(
      allData?.[bedP.proceedCleansing] === 1 ? remarkP.TERMINAL_DISINFECTION_ONGOING : remarkP.TERMINAL_DISINFECTION
    );
  }
  if (allData?.[bedP.returnDayCase] === 'Y') {
    newRarks.push(remarkP.RETURN_DAY_CASE);
  } else if (allData?.[bedP.forClinicalAdmission] || allData?.[bedP.transferInRequestInfo]) {
    newRarks.push(remarkP.PENDING_ADMISSION);
  }

  if (allData?.[bedP.resuscitation]) {
    newRarks.push(remarkP.RESUSITATION);
  }
  if (allData?.[bedP.maintenance]) {
    newRarks.push(remarkP.MAINTANIENCE);
  }
  if (allData?.[bedP.lifeSavingEquipment]) {
    newRarks.push(remarkP.LIFE_SAVING_EQUIPMENT);
  }
  if (allData?.[bedP.attention]) {
    newRarks.push(remarkP.ATTENTION);
  }
  // 新加的elder home icon
  if (allData?.[bedP.elderlyHome]) {
    newRarks.push(remarkP.ELDERLY_HOME);
  }
  handleNewRemarks(allData, newRarks);

  handleUnavailableRemark(allData, status, newRarks);

  if (editFloorPlan) {
    return handleEditModeReturnRemarks(status, newRarks);
  } else {
    return [...newRarks, allData?.status]; // this method return an array to save local bed status and join with remote bed status
  }
};
// 判断bed status床位状态显示哪些icon的方法 -------- end -------

const encryptKey = '1234567890123456';
export const encryptHkid = async (hkid) => {
  try {
    if (hkid) {
      const encryptResult = await aesGcmUtil.encryptMessage(hkid, encryptKey);
      return encryptResult;
    }
  } catch (error) {
    console.log(error);
  }
};

export const decryptHkid = async (hkid) => {
  try {
    if (hkid) {
      const decryptResult = await aesGcmUtil.decryptMessage(hkid, encryptKey);
      return decryptResult;
    }
  } catch (error) {
    console.log(error);
    return hkid;
  }
};

export const revampTableList = async (list) => {
  if (!Array.isArray(list)) return [];
  try {
    const newList = await Promise.all(
      _.map(list, async (item) => {
        return item?.hkid ? { ...item, hkid: await decryptHkid(item?.hkid) } : item;
      })
    );
    return newList;
  } catch (error) {
    console.log('error: ', error);
  }
};

export const formatSecondsToTime = (seconds) => {
  if (seconds === null || seconds === undefined || isNaN(seconds)) {
    return '';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  return `${hours} hrs ${minutes} mins`;
};

export const formatTimestamp = (timestamp, format = 'YYYY-MM-DD HH:mm') => {
  if (!timestamp && timestamp !== 0) return '';
  const d = new Date(timestamp);
  if (isNaN(d.getTime())) return '';

  const formatMap = {
    YYYY: d.getFullYear(),
    MM: String(d.getMonth() + 1).padStart(2, '0'),
    DD: String(d.getDate()).padStart(2, '0'),
    HH: String(d.getHours()).padStart(2, '0'),
    mm: String(d.getMinutes()).padStart(2, '0'),
    ss: String(d.getSeconds()).padStart(2, '0'),
  };

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, (match) => formatMap[match]);
};

// 点击床的时候根据床的各种状态判断出哪一个popup
// 每个状态对应的popup
const bedPop = {
  [bsApp.OCCUPIED]: Occupieddischarge,
  [bsApp.UNAVAILABLE]: Available,
  [bsApp.AVAILABLE]: AvaliableUnavaliableTbc,
  [bsApp.TBC]: TbcAvailable,
  [bsApp.DISCHARGING]: Canceldischarge,
  [bsApp.MISSING]: Occupieddischarge,
  [bsApp.MISSING_CLOSED]: Occupieddischarge,
};

const noop = () => {};
export const showPopOptimized = ({
  allData,
  showPopup,
  updateBedStatus,
  closePop,
  saveBedStatus,
  saveReturnDayCase,
  reload,
}) => {
  const isOpenFlag = showPopup ?? false;
  const Pop = bedPop[allData?.[bedP.status]];

  if (!Pop) return <div />;
  const newProps = {
    updateBedStatus: updateBedStatus ?? noop,
    closePop: closePop ?? noop,
    saveBedStatus: saveBedStatus ?? noop,
    saveReturnDayCase: saveReturnDayCase ?? noop,
    reload: reload ?? noop,
  };

  return <Pop allData={allData} open={isOpenFlag} {...newProps} />;
};

export const getCubicleV2DisplayBedNo = ({ isLinked, linkedBedNo, status, bedNo }) => {
  // 是linked的情况并且patient status === 'O' 的时候 show 原来的bedNo,否则show linkedBedNo
  // 不是linked的情况 show bedNo
  if (!isLinked) {
    return bedNo;
  } else {
    return status === bsApp.OCCUPIED ? bedNo : linkedBedNo;
  }
};
export const getCubicleV2DisplayWardNo = ({ isLinked, isMutipleWardCode, status, ward }) => {
  // 只有一个ward no(isMutipleWardCode = false)的时候，不show ward no
  // 是linked的并且 patient status === 'O' 的时候 show ward no, 否则不 show ward no
  // 不是linked的情况 ward no
  if (!isMutipleWardCode) return '';
  return !isLinked || (isLinked && status === bsApp.OCCUPIED) ? ward : '';
};

// 将rem单位转成px
export const calculateRemToPx = (remVal) => {
  // 获取html标签的fontsize
  const htmlElement = document.documentElement;
  const computedStyle = window.getComputedStyle(htmlElement);
  const fontSize = parseFloat(computedStyle.fontSize) || 14;
  // 将传进来的rem值转成number
  const rem = Number(remVal) || 0;
  return Math.round(rem * fontSize);
};

export const getLsolationPrecaution = (classes, allData) => {
  const isolationPrecaution = [
    {
      typeName: bsApp.AIRBORNE_PRECAUTION,
      text: i18n.t('BEDSTATUS_AIRBORNE_PRECAUTION'),
      key: bedP.airbornePrecaution,
    },
    { typeName: bsApp.DROPLET_PRECAUTION, text: i18n.t('BEDSTATUS_DROPLET_PRECAUTION'), key: bedP.dropletPrecaution },
    { typeName: bsApp.CONTACT_PRECAUTION, text: i18n.t('BEDSTATUS_CONTACT_PRECAUTION'), key: bedP.contactPrecaution },
    { typeName: bsApp.REVERSE_LSOLATION, text: i18n.t('BEDSTATUS_REVERSE_LSOLATION'), key: bedP.reverseLsolation },
    { typeName: bsApp.COVID_19, text: i18n.t('BEDSTATUS_COVID_19'), key: bedP.covidPositivePat },
  ];

  const result = _.map(isolationPrecaution, (item, index) => {
    return allData?.[item.key] ? (
      <div key={getArrayRandomKey(index, 'isolationPrecaution')} style={{ margin: '1rem 0' }}>
        <Box display="flex" alignItems="center" gridGap="0.5rem">
          <RemaksIcon typeName={item.typeName} />
          <Typography className={classes.remaksText}>{item.text}</Typography>
        </Box>
      </div>
    ) : (
      <div key={getArrayRandomKey(index, 'isolationPrecaution')} />
    );
  });
  return result.reduce((preItem, nexItem) => preItem + nexItem) ? (
    result
  ) : (
    <Typography className={classes.attentionItem}>{i18n.t('BEDSTATUS_N_A')}</Typography>
  );
};

export const getAttention = (classes, allData) => {
  let temp;
  if (_.isArray(allData?.attention)) {
    temp = _.map(allData?.attention, (item, index) => {
      return (
        <Typography key={getArrayRandomKey(index, 'attention')} className={classes.attentionItem}>
          {item.name}
        </Typography>
      );
    });
  }
  return initValue(temp);
};

export const getDefaultCode = (list) => {
  // 当只有一个option的时候，返回第一个option的val
  let defaultCode = '';
  if (Array.isArray(list) && list.length === 2) {
    defaultCode = list[1]?.value;
  }
  return defaultCode;
};

export const getAssignedWardLocationOptions = (wardLocationList = []) => {
  const assignedWardLocationOptions = _.map(wardLocationList, (item) => ({
    text: item?.wardLocation,
    value: item?.wardLocation,
    wardCds: item?.wardCds,
  }));
  assignedWardLocationOptions.unshift({ text: '\u2002', value: null });
  const defaultWardLocation = getDefaultCode(assignedWardLocationOptions);
  return { defaultWardLocation, assignedWardLocationOptions };
};

export const getAssignedWardCodeOptions = (wardLocList, wardLocVal) => {
  if (!wardLocVal) return [];
  const wardCodeList = _.find(wardLocList, (item) => item?.value === wardLocVal)?.wardCds || [];
  const revampWardCodeList = _.map(wardCodeList, (item) => ({
    ...item,
    text: item?.wardCd,
    value: item?.wardCd,
  }));
  revampWardCodeList.unshift({ text: '\u2002', value: null });
  return revampWardCodeList;
};

export const getAssignedBedNoOptions = (wardCodeList, wardCodeVal) => {
  if (!wardCodeVal) return [];
  const bedNoList = _.find(wardCodeList, (item) => item?.value === wardCodeVal)?.bedNos || [];
  const revampBedNoList = _.map(bedNoList, (item) => ({
    ...item,
    text: `${item.bedNo} (${item.status},${item.type})`,
    value: item.bedNo,
  }));
  revampBedNoList.unshift({ text: '\u2002', value: null });
  return revampBedNoList;
};

export const getTransferInOutAdmissionTypeList = (bsMlookupList) => {
  if (!Array.isArray(bsMlookupList)) return [];
  const listFromApi = bsMlookupListFunc.getTypeLookupFormat(bsMlookupList, 'bs_clinical_admission');
  return _.filter(listFromApi, (item) => item?.value !== 'EADM');
};

export const isNotEmptyArray = (list) => {
  return Array.isArray(list) && list?.length > 0;
};
